export enum ADDRESS {
    MX = 'Londres 241, Piso 4, Col. Juárez, Cuauhtémoc, Ciudad de México, 06600, México',
    AR = 'Av. Del Libertador 4980, 7B, CP 1426, CABA, Argentina',
    CO = 'Calle 93 11 A 28 OF 601 Centro Empresarial CAPITAL PARK 93, Bogotá D.C., Colombia',
}
